import isNull from "lodash/isNull";
import isUndefined from "lodash/isUndefined";

export function normalizeQuestionnaireArrayValue<T>(maybeArray?: T | T[]) {
  if (isUndefined(maybeArray) || isNull(maybeArray)) return [];

  return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
}
